import { StencilCDNImage } from '@/components/Common/StencilImage'

export default function Logo() {
  return (
    <div className="w-26 md:w-36">
      <StencilCDNImage
        src="https://indcdn.indmoney.com/public/images/fe/IND_logo_white_tm.png"
        alt="Download IND Money app on app store"
        width={130}
        height={50}
        unoptimized
      />
    </div>
  )
}
